import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "lib/utils";

// Token-styled spinner replacing Bootstrap's .spinner-border.
const Spinner = React.forwardRef(({ className, ...props }, ref) => (
  <Loader2
    ref={ref}
    className={cn("h-5 w-5 animate-spin text-primary", className)}
    role="status"
    aria-label="Loading"
    {...props}
  />
));
Spinner.displayName = "Spinner";

export { Spinner };
